import { render, staticRenderFns } from "./Modify.vue?vue&type=template&id=64655074&scoped=true"
import script from "./Modify.vue?vue&type=script&lang=js"
export * from "./Modify.vue?vue&type=script&lang=js"
import style0 from "./Modify.vue?vue&type=style&index=0&id=64655074&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64655074",
  null
  
)

export default component.exports